import { render, staticRenderFns } from "./_pre-orders.tab.vue?vue&type=template&id=41d27ffa&scoped=true"
import script from "./_pre-orders.tab.vue?vue&type=script&lang=js"
export * from "./_pre-orders.tab.vue?vue&type=script&lang=js"
import style0 from "./_pre-orders.tab.vue?vue&type=style&index=0&id=41d27ffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d27ffa",
  null
  
)

export default component.exports